// // PricingTable.js
// import React from 'react'
// import { motion } from 'framer-motion'
// import { HiCheck, HiSparkles, HiShieldCheck, HiClock, HiSupport } from 'react-icons/hi'

// const PricingTable = () => {
//   const plans = [
//     {
//       name: "Weekly Flex",
//       price: "$8",
//       period: "week",
//       description: "Quick Boost",
//       features: [
//         "AI-powered resume generation",
//         "Smart cover letter creator",
//         "Job-specific resume optimization",
//         "Real-time application tracking",
//         "24/7 AI chat support"
//       ],
//       ctaText: "Start Your Week Strong"
//     },
//     {
//       name: "Monthly Pro",
//       price: "$28",
//       period: "month",
//       description: "Best Value",
//       features: [
//         "All Weekly Flex features",
//         "Unlimited resume generations",
//         "Advanced resume analytics",
//         "LinkedIn profile optimization",
//         "Interview preparation AI assistant",
//         "Priority customer support"
//       ],
//       ctaText: "Accelerate Your Career"
//     }
//   ]

//   return (
//     <div className="relative py-32 bg-white">
//       {/* Background Decorations */}
//       <div className="absolute inset-0 z-0">
//         <div className="absolute top-1/4 right-0 w-96 h-96 bg-indigo-50 rounded-full mix-blend-multiply filter blur-xl opacity-70" />
//         <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-purple-50 rounded-full mix-blend-multiply filter blur-xl opacity-70" />
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
//         {/* Header */}
//         <div className="text-center mb-24">
//           <span className="inline-flex items-center gap-2 bg-indigo-50 rounded-full px-4 py-2 mb-8">
//             <HiSparkles className="w-5 h-5 text-indigo-600" />
//             <span className="text-indigo-600 text-sm font-medium">
//               Professional Resume Builder
//             </span>
//           </span>
//           <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
//             Simple pricing for all your needs
//           </h2>
//           <p className="text-lg text-neutral-600 max-w-2xl mx-auto mb-12">
//             Choose a plan that works best for your career goals. All prices are in US Dollars.
//           </p>

//           {/* Benefits */}
//           <div className="flex flex-wrap justify-center gap-8">
//             {[
//               { icon: <HiShieldCheck />, text: "Secure Payment" },
//               { icon: <HiClock />, text: "Cancel Anytime" },
//               { icon: <HiSupport />, text: "24/7 Support" }
//             ].map((benefit, index) => (
//               <div key={index} className="flex items-center gap-2 text-neutral-600">
//                 <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600">
//                   {benefit.icon}
//                 </div>
//                 <span className="text-sm font-medium">{benefit.text}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Pricing Cards */}
//         <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto mb-20">
//           {plans.map((plan, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: index * 0.1 }}
//               className="bg-white rounded-2xl p-10 border"
//             >
//               <div className="space-y-8">
//                 {/* Plan Header */}
//                 <div>
//                   <div className="flex items-center justify-between mb-6">
//                     <h3 className="text-2xl font-bold text-neutral-900">
//                       {plan.name}
//                     </h3>
//                     <span className="inline-block px-3 py-1 bg-indigo-50 text-indigo-600 text-sm font-medium rounded-full">
//                       {plan.description}
//                     </span>
//                   </div>
//                   <div className="flex items-baseline gap-2 mb-6">
//                     <span className="text-5xl font-bold text-neutral-900">
//                       {plan.price}
//                     </span>
//                     <span className="text-neutral-600">
//                       /{plan.period}
//                     </span>
//                   </div>
//                 </div>

//                 {/* Features List */}
//                 <ul className="space-y-5">
//                   {plan.features.map((feature, idx) => (
//                     <li key={idx} className="flex items-center gap-3">
//                       <div className="w-5 h-5 rounded-full bg-indigo-50 flex items-center justify-center">
//                         <HiCheck className="w-4 h-4 text-indigo-600" />
//                       </div>
//                       <span className="text-sm text-neutral-600">
//                         {feature}
//                       </span>
//                     </li>
//                   ))}
//                 </ul>

//                 {/* Get Started Button */}
//                 <button className="w-full py-4 rounded-xl text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 transition-colors" onClick={() => window.open("https://app.resumeflex.com", "_blank")}>
//                   {plan.ctaText}
//                 </button>
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* Bottom Section */}
//         <div className="text-center space-y-6">
//           <div className="inline-flex items-center gap-2 bg-green-50 rounded-full px-4 py-2">
//             <HiShieldCheck className="w-5 h-5 text-green-600" />
//             <span className="text-green-600 text-sm font-medium">
//               Your data is safe with us
//             </span>
//           </div>
//           <p className="text-sm text-neutral-600">
//             Questions? Contact our support team 24/7
//           </p>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default PricingTable


// PricingTable.js
import React from 'react'
import { motion } from 'framer-motion'
import { HiCheck, HiSparkles, HiShieldCheck, HiClock, HiSupport, HiDocumentText, HiChatAlt } from 'react-icons/hi'

const PricingTable = () => {
  const plans = [
    {
      name: "Weekly Sprint",
      price: "$8",
      period: "week",
      description: "Quick Career Boost",
      features: [
        "Unlimited AI Resume Generation",
        "Unlimited AI Chat Interactions",
        "Cover Letter & Email Generator",
        "AI-powered Customization Tools",
        "Job-specific Optimization Engine",
        "Real-time Resume Analysis"
      ],
      ctaText: "Start Your Success Journey",
      highlight: "Flexible Start"
    },
    {
      name: "Monthly Accelerator",
      price: "$28",
      period: "month",
      description: "Best Value",
      features: [
        "All Weekly Sprint Features",
        "30% Monthly Savings",
        "Extended Usage Period",
        "Unlimited Document Generation",
        "Priority AI Assistance",
        "Advanced Job Matching"
      ],
      ctaText: "Maximize Your Potential",
      highlight: "Most Popular"
    }
  ]

  const benefits = [
    {
      icon: <HiDocumentText />,
      title: "One-Click Generation",
      description: "Create professional documents instantly"
    },
    {
      icon: <HiChatAlt />,
      title: "AI Assistant",
      description: "24/7 intelligent career guidance"
    },
    {
      icon: <HiShieldCheck />,
      title: "Quality Assured",
      description: "AI-powered optimization"
    }
  ]

  return (
    <div className="relative py-32 bg-white">
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-indigo-50 rounded-full mix-blend-multiply filter blur-xl opacity-70" />
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-purple-50 rounded-full mix-blend-multiply filter blur-xl opacity-70" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-24">
          <span className="inline-flex items-center gap-2 bg-indigo-50 rounded-full px-4 py-2 mb-8">
            <HiSparkles className="w-5 h-5 text-indigo-600" />
            <span className="text-indigo-600 text-sm font-medium">
              AI-Powered Career Success
            </span>
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
            Choose Your Success Path
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto mb-12">
            Transform your job search with AI-powered tools. No commitment required - cancel anytime.
          </p>

          <div className="flex flex-wrap justify-center gap-8 mb-16">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-3 bg-white rounded-full px-6 py-3 shadow-sm">
                <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600">
                  {benefit.icon}
                </div>
                <div className="text-left">
                  <h3 className="text-sm font-semibold text-neutral-900">{benefit.title}</h3>
                  <p className="text-xs text-neutral-600">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-2xl p-8 border border-neutral-200 hover:border-indigo-200 transition-all duration-300 hover:shadow-lg"
            >
              <div className="space-y-6">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-2xl font-bold text-neutral-900 mb-2">{plan.name}</h3>
                    <div className="flex items-baseline gap-2">
                      <span className="text-4xl font-bold text-neutral-900">{plan.price}</span>
                      <span className="text-neutral-600">/{plan.period}</span>
                    </div>
                  </div>
                  <span className="inline-block px-3 py-1 bg-indigo-50 text-indigo-600 text-sm font-medium rounded-full">
                    {plan.highlight}
                  </span>
                </div>

                <ul className="space-y-4">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3">
                      <HiCheck className="w-5 h-5 text-indigo-600" />
                      <span className="text-sm text-neutral-600">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button 
                  className="w-full py-4 px-6 rounded-xl text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 transition-colors duration-300"
                  onClick={() => window.open("https://app.resumeflex.com", "_blank")}
                >
                  {plan.ctaText}
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-green-50 rounded-full px-4 py-2 mb-4">
            <HiShieldCheck className="w-5 h-5 text-green-600" />
            <span className="text-green-600 text-sm font-medium">
              Secure & Trusted Platform
            </span>
          </div>
          <p className="text-sm text-neutral-600">
            Questions? Our support team is available 24/7
          </p>
        </div>
      </div>
    </div>
  )
}

export default PricingTable